import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { pageKey } from '@dashboard/lib/queryKeys';

export function useStaffInviteSubject(pageId: string, initialSubject: string) {
  const { token } = useAuth();
  const qc = useQueryClient();

  type PageCache = { eventDetails?: { staffInviteSubject?: string } } & Record<string, unknown>;
  const m = useMutation({
    mutationFn: (subject: string) =>
      fetcher(`/scanner/${pageId}/staff-invite-subject`, token, {
        method: 'PATCH',
        body: JSON.stringify({ subject }),
      }).then((data: { subject?: string } | undefined) => data?.subject ?? subject),
    onSuccess: saved => {
      qc.setQueryData<PageCache | undefined>(pageKey(pageId), old =>
        old
          ? {
              ...old,
              eventDetails: { ...(old.eventDetails ?? {}), staffInviteSubject: saved },
            }
          : old,
      );
    },
  });

  return {
    subject: initialSubject,
    save: m.mutateAsync,
    isSaving: m.isPending,
  };
}
